const Template=`<div>
<div class="phone-list-table">
        <b-table
        :items="phones"
        :fields="fields"
        striped
        dark
        hover
        borderless>

        <template v-slot:cell(action)="data">
        <b-button class="icons" v-on:click="showModal(data.item)"><img src="css/edit.svg"></b-button>
        </template>

        <template v-slot:cell(delete)="data">
        <b-button v-on:click="showDeleteModal(data.item)" class="icons"><img src="css/delete.svg"></b-button>
        </template>
        </b-table>
    </div>
    <div class="buttons">
    <b-button v-on:click="showCreateModal()">{{$t('phoneList.addEmployee')}}</b-button>
    
    <b-modal ref="EditModal" hide-footer
    header-bg-variant="dark"
    header-text-variant="light"
    :title="$t('phoneList.editDetails')">
      <b-form-group label-for="name-input">
      <b-col v-for="field in options">
      <label>{{field.namelabel}}</label>
        <b-form-input
        v-model="field.info">
        </b-form-input>
        </b-col>

        <b-col>
        <b-form-checkbox
         v-model="default_phone"
         value="true"> 
         {{$t('phoneList.defaultContact')}}
         </b-form-checkbox>
        </b-col>
      </b-form-group>
      <b-button class="mt-4" block variant="success" @click="editPhone(options)">{{$t('phoneList.edit')}}</b-button>
      <b-button class="mt-2" block variant="dark" @click="hideModal">{{$t('phoneList.cancel')}}</b-button>
  </b-modal>


  <b-modal ref="CreateModal" hide-footer
    header-bg-variant="dark"
    header-text-variant="light"
    :title="$t('phoneList.addNewEmployee')">
    <b-container fluid>
    <b-row v-for="type in types">
     <b-col sm="12">
     <label for="input-live">{{type.namelabel}}</label>
     <b-form-input
     v-model="type.info" trim>
     </b-form-input>
     </b-col>
     </b-row>

     <b-row>
     <b-col sm="12">
     <b-form-checkbox
     v-model="default_phone"
     value="true"> 
     {{$t('phoneList.defaultContact')}}
     </b-form-checkbox>
     </b-col>
     </b-row>

     <b-row>
     <b-col sm="12">
     <b-button class="mt-4" block variant="success" v-on:click="createPhone">{{$t('phoneList.add')}}</b-button>
     </b-col>
     </b-row>
</b-container>
  </b-modal>

  <b-modal
  ref="deleteModal" hide-footer
  header-bg-variant="dark"
  header-text-variant="light"
  title="Удаление сотрудника">
  
  <div>
        <h5>{{message}}</h5>
  </div>
    <b-button class="mt-3" block variant="success" @click="deletePhone()">Удалить элемент</b-button>
    <b-button class="mt-3" block variant="dark" @click="hideDeleteModal()">Отмена</b-button>
</b-modal>

</div>
</div>`
export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page6_phones/template.js